var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBallot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8 14H20.4V16.4H21.24C21.4388 16.4 21.6 16.535 21.6 16.7V17.3C21.6 17.465 21.4388 17.6 21.24 17.6H2.76C2.56125 17.6 2.4 17.465 2.4 17.3V16.7C2.4 16.535 2.56125 16.4 2.76 16.4H3.6V14H1.2C0.53625 14 0 14.5362 0 15.2V18.8C0 19.4637 0.53625 20 1.2 20H22.8C23.4638 20 24 19.4637 24 18.8V15.2C24 14.5362 23.4638 14 22.8 14ZM19.2 16.4V4.4112C19.2 3.73995 18.6563 3.19995 17.9888 3.19995H6.015C5.34375 3.19995 4.8 3.7437 4.8 4.4112V16.4H19.2ZM7.92 9.57495L8.87625 8.6262C9.03375 8.4687 9.28875 8.4687 9.44625 8.62995L10.995 10.19L14.565 6.64995C14.7225 6.49245 14.9775 6.49245 15.135 6.6537L16.0837 7.60995C16.2413 7.76745 16.2413 8.02245 16.08 8.17995L11.2688 12.95C11.1113 13.1075 10.8562 13.1075 10.6987 12.9462L7.92 10.145C7.75875 9.98745 7.7625 9.73245 7.92 9.57495Z",
    fill: "#66676B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallot);
export default __webpack_public_path__ + "static/media/ballot.3bdae05c99055664c2a701f561bb221d.svg";
export { ForwardRef as ReactComponent };